import { Component } from '@angular/core';

@Component({
  selector: 'app-anon-layout',
  templateUrl: './anon-layout.component.html',
  styleUrl: './anon-layout.component.scss',
  standalone: false
})
export class AnonLayoutComponent {

}
